import React, { useEffect, useState, useLayoutEffect} from "react";

//Styles
import "./generalReports.css";

//Com
import FilterBox from "../../Components/filterBox/filterBox";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import "./generalReports.css";


const reportReasonsRefuse = () => {

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filters, setFilters] = useState([]);
  const [control,setControl] = useState([1]);
  const [loading, setLoading] = useState(true);

    //Esse use effect faz a requisição na api e puxa os dados pela primeira vez. Coloquei o nome de componentDidMount() pois ele executa somente na primeira renderização.

    useEffect(() => {
        function firstLoad() {
            let array = [];
            Api.get("/refuse-reasons")
            .then((response) => {
              
            response.data.forEach((element) => {
              array.push({
                Código: element.code,
                Motivo: element.description,
              });
              
            });
            if (array.length > 0) {
              //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
                setData(array);
                setDataFilter(array);
                setLoading(false);
            };
           
          })
          .catch((err) => {
            alert(err);
          });  
        }

        firstLoad();
        
    },[])

    //Essa função serve para capturarmos e armazenarmos em um state "filters" o que está sendo digitado nos filtros.

    const saveText = (element) => {
      
        const {value, name} = element;
        setFilters({[`${name}`]:(value)});
        
    }

    const button = () => {
      setLoading(true);
      setControl([...[1]])
    } 

    // Essa função é executada quando clicamos em um botão.

    useEffect(()=>{
      //Captura o nome dos filtros que estão sendo usados.
      let aux = Object.keys(filters);
      //Se existir uma filtragem ele usa a função .filter para filtrar o state data e armazenar em uma variável arr. 
      if(aux.length > 0 && filters[aux] != null && filters[aux] != ""){
          let arr = data.filter(element => (element[aux] == filters[aux]));
          
          //Depois ele armazena a varíavel arr no state dataFilter;
          setDataFilter([...arr]);
        
          console.log("State 'dataFilter'");
          console.log(dataFilter);

      }else{
        setDataFilter([...data]);
      }

      setLoading(false);
    },[control])

    
    return(
      <div className="filters boxReport">
      <FilterBox title="Filtros">
      <div className="elementFilter" type="input">
              <InputReport name="Código" title="Código" parentCallback={saveText} max={3} value={filters['Código']} validationType="varchar" focus={true}/>
          </div>
          <div className="elementFilter" type="input">
              <InputReport name="Motivo" title="Motivo" parentCallback={saveText} max={45} value={filters['Motivo']} validationType="varchar"/>
          </div>
          <div className="buttonFilter" type="button">
              <Button size title="Gerar" icon="faGear" parentCallback={button}/>
          </div>
      </FilterBox>
      <div className="TableReport" id="tabela">
      {loading ? (
        
        <div style={{ marginTop: '20vh' }} className={styles.loader}>
          <Spinner variant="success" animation="border" />
          <strong>Carregando...</strong>
        </div>         
    ) : (
      <>
        {dataFilter.length > 0 ? (

            <TableList data={dataFilter}></TableList>
            
        ) : (

            <MessageTable message={"Sem dados para processar."} />

        )}
        </>
    )}
       </div>
    </div>
    );
};

export default reportReasonsRefuse;